import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomBtn from "components/fragments/CustomBtn";
import CustomInputSearch from "components/fragments/CustomInputSearch";
import ProductOrderDetail from "pages/pos-menus/pos/ProductOrderDetail";
import { useDispatch, useSelector } from "react-redux";
import { billHandler, posHandler } from "../../redux/handlers";
import moment from "moment";

const REVERSED_BILL_STATUS_MAP = new Map([
  [null, ""],
  [1, "PENDING"],
  [2, "PENDING"],
  [3, "COMPLETED"],
  [4, "CANCELED"],
  [5, "RETURNED"],
]);

const DELIVERY_OPTIONS_MAP = new Map([
  ["DINE_IN", 1],
  ["TAKEAWAY", 2],
  ["DELIVERY", 3],
]);

const ModalCallBill = forwardRef(
  (
    {
      modalSuccessOpenObj,
      modalOpenObj,
      setOrders,
      alertObj,
      currentBranchId,
      businessSlug,
      ...props
    },
    ref
  ) => {
    const billItem = useSelector((state) => state.bill.data);
    const { branch } = useSelector((state) => state.pos);
    const loading = useSelector((state) => state.common.loading);
    const dispatch = useDispatch();
    const [BillStatus, setBillStatus] = useState(2);
    const [billdatalist, setBilldatalist] = useState([]);
    const [holdBill, setHoldBill] = useState([]);
    const [billdata, setBilldata] = useState(false);
    const [filterText, setFilterText] = useState("");
    const billStatusFilter = "";
    const [pointOfSaleInfo, setPointOfSaleInfo] = useState(null);
    const [recallBill, setRecallBill] = useState([]);
    const branchPOSSellingId = localStorage.getItem("branchPOSSelling");
    const selectedDate = moment().format("YYYY-MM-DD");

    const billfilter = billdatalist.filter(
      (item) =>
        (item.orderNo &&
          item.orderNo.toLowerCase().includes(filterText.toLowerCase()) &&
          BillStatus === item.billStatus) ||
        (item.pos &&
          item.pos.toLowerCase().includes(filterText.toLowerCase()) &&
          BillStatus === item.billStatus) ||
        (item.customerName &&
          item.customerName.toLowerCase().includes(filterText.toLowerCase()) &&
          BillStatus === item.billStatus)
    );

    const convertOrdersToBillFormat = useCallback(
      (pendingOrders) => {
        if (!pendingOrders) return [];

        return pendingOrders.map((pendingOrder) => {
          const orderDetails = JSON.parse(pendingOrder.data);

          const deliveryTypeMapping = {
            DINE_IN: 1,
            TAKEAWAY: 2,
            DELIVERY: 3,
          };
          const posTerminalName =
            pointOfSaleInfo &&
            Array.isArray(pointOfSaleInfo) &&
            pointOfSaleInfo.length > 0
              ? pointOfSaleInfo[0].name
              : "-";

          let employeeName = "";
          if (
            pointOfSaleInfo &&
            pointOfSaleInfo.length > 0 &&
            pointOfSaleInfo[0].branchPosSelling &&
            pointOfSaleInfo[0].branchPosSelling.length > 0
          ) {
            if (pointOfSaleInfo[0].userBusinessGroup) {
              const { first_name, last_name } =
                pointOfSaleInfo[0].userBusinessGroup;
              employeeName = `${first_name || ""} ${last_name || ""}`.trim();
            } else {
              const { first_name, last_name } =
                pointOfSaleInfo[0].branchPosSelling[0].userBusinessGroup;
              employeeName = `${first_name || ""} ${last_name || ""}`.trim();
            }
          }

          const orderItems = orderDetails.product
            ? orderDetails.product.map((productItem) => ({
                id: productItem.id,
                productID: productItem.productID,
                productImage: productItem.productImage,
                productName: productItem.productName,
                productPrice: productItem.productPrice.toString(),
                productSumPrice: parseFloat(productItem.productSumPrice),
                productQty: productItem.productQty,
                productStatus: productItem.productStatus,
                annotationOptions: productItem.annotationOptions || [],
                specificOptions: [
                  ...(Array.isArray(productItem?.productOptions)
                    ? productItem.productOptions
                    : []),
                  ...(Array.isArray(productItem?.specificOptions)
                    ? productItem.specificOptions
                    : []),
                ],
                standardOptions: productItem.standardOptions || [],
                note: productItem.note || "",
              }))
            : [];
          let orderPrice = {
            sumprice:
              Number(orderDetails.orderPrice.sumprice).toFixed(2) ||
              Number(0).toFixed(2),
            discount:
              Number(orderDetails.orderPrice.discount).toFixed(2) ||
              Number(0).toFixed(2),
            vat:
              Number(orderDetails.orderPrice.vat).toFixed(2) ||
              Number(0).toFixed(2),
            net:
              Number(orderDetails.orderPrice.net).toFixed(2) ||
              Number(0).toFixed(2),
          };
          const uniqueId = String(pendingOrder.id);

          return {
            billID: pendingOrder.id,
            id: uniqueId,
            receiptNo: "-",
            pos: posTerminalName,
            billStatus: 2,
            staff: employeeName || "-",
            customerID: orderDetails.memberID,
            customerName: orderDetails.memberName || "",
            orderNo: "-",
            orderDate: new Date(pendingOrder.created_at).toLocaleDateString(
              "th-TH"
            ),
            billOpenTime: null,
            billPaymentTime: null,
            tableID: orderDetails.tableID || "",
            tableName: orderDetails.tableDetails?.tableNo || "",
            zone: orderDetails.tableDetails?.zoneName || "",
            delivery: deliveryTypeMapping[pendingOrder.order_type] || 1,
            taxInvoice: null,
            product: orderItems,
            orderPrice: orderPrice,
            payment: [],
            rawOrderData: orderDetails,
          };
        });
      },
      [pointOfSaleInfo]
    );

    const pendingBillConverter = useCallback(
      (bill) => {
        const filter = REVERSED_BILL_STATUS_MAP.get(billStatusFilter);
        let count = {
          open: 0,
          pending: 0,
          completed: 0,
          CANCELED: 0,
          return: 0,
          total: 0,
        };

        let updateBillItem = [];
        if (Array.isArray(bill)) {
          updateBillItem = bill?.map((item) =>
            mapBillItem(item, filter, count)
          );
        } else if (bill && typeof bill === "object") {
          updateBillItem = [mapBillItem(bill, filter, count)];
        }

        function mapBillItem(item, filter, count) {
          if (filter === undefined) {
            count.total += 1;
            if (item.status === "OPEN") {
              count.open += 1;
            } else if (item.status === "PENDING") {
              count.open += 1;
            } else if (item.status === "COMPLETED") {
              count.completed += 1;
            } else if (item.status === "CANCELED") {
              count.CANCELED += 1;
            } else if (item.status === "RETURNED") {
              count.return += 1;
            }
          }
          let currentTotalPrice = 0;
          let productStatus = 0;

          const uniqueId = String(item.id);

          return {
            id: uniqueId,
            billID: item.order_id,
            receiptNo: item.receipt_no || "",
            pos: item.order.branchPosSelling.branchPos.name,
            billStatus: 1,
            staff:
              item.userBusinessGroup.first_name +
              " " +
              item.userBusinessGroup.last_name,
            customerID: item.member_id,
            customerName: "",
            orderNo: item.order.code,
            orderDate: moment(item.order.created_at).format("DD/MM/YYYY"),
            billOpenTime: null,
            billPaymentTime: null,
            tableID: "",
            tableName: "",
            zone: "",
            delivery: DELIVERY_OPTIONS_MAP.get(item.order.order_type),
            taxInvoice: null,
            product: item.billItems?.map((items) => {
              if (items.orderItem?.status_kitchen !== "ORDER_CANCEL") {
                currentTotalPrice += Number(items.price);
              }
              if (
                items.orderItem.quantity - items.orderItem.quantity_removed <
                items.orderItem.quantity
              ) {
                productStatus = 3;
              }
              return {
                id: items.id,
                productID: items.orderItem.product?.id || items.orderItem.product_id,
                productImage: items.orderItem.product?.image_path || null,
                productPrice: items.price,
                productQty:
                  items.orderItem.quantity - items.orderItem.quantity_removed,
                productName: items.orderItem.product?.name || items.orderItem.item_name || '-',                
                productSumPrice: items.price,
                note: items.orderItem.remark,
                annotationOptions: items.orderItem.orderProductAnnotation?.map(
                  (note) => ({
                    itemName: note.productAnnotationItem.name,
                    listID: note.id,
                  })
                ),
                specificOptions: items.orderItem.orderProductOption?.map(
                  (option) => ({
                    itemName: option.productOptionItem.name,
                    listID: option.id,
                  })
                ),
                standardOptions:
                  items.orderItem.orderProductSpecificOption?.map(
                    (standard) => ({
                      itemName: standard.productSpecificOptionItem.name,
                      listID: standard.id,
                    })
                  ),
                isCancel: items.orderItem.status_kitchen === "ORDER_CANCEL",
                productStatus,
              };
            }),

            payment: [],
            rawOrderData: {
              product: item.billItems.map((billItem) => {
                return {
                  id: billItem.orderItem.id.toString(),
                  productID: billItem.orderItem.product_id,
                  productImage: billItem.orderItem.image_path,
                  productName:
                    billItem.orderItem.item_name ||
                    billItem.orderItem.product?.name || '-',
                  productPrice: billItem.price,
                  productSumPrice: billItem.price,
                  productQty: billItem.quantity,
                  productStatus: productStatus,
                  optionnote: [],
                  optionproduct: [],
                  optionstandard: [],
                  note: billItem.orderItem.remark,
                  displayPrice: billItem.price,
                };
              }),
              orderNo: item.order.code,
              tableID: "",
              orderPrice: {
                sumprice: currentTotalPrice.toFixed(2),
                discount: item.discount_amount,
                vat: item.vat,
                net: Number(item.final_amount) || Number(item.total_price),
              },
            },
            orderPrice: {
              discount: item.discount_amount,
              vat: item.vat,
              net: Number(item.final_amount) || Number(item.total_price),
              sumprice: currentTotalPrice.toFixed(2),
            },
          };
        }
        return updateBillItem;
      },
      [billStatusFilter]
    );

    const fetchBillItem = useCallback(async () => {
      const res = await dispatch(
        billHandler.getBill(
          businessSlug,
          branchPOSSellingId,
          undefined,
          "PENDING"
        )
      );
      setRecallBill(res);
      if (
        branch?.employee_info?.userBusinessGroup?.branchPosSelling &&
        branch?.employee_info?.userBusinessGroup?.branchPosSelling.length > 0
      ) {
        const lastIndex =
          branch.employee_info.userBusinessGroup.branchPosSelling.length - 1;
        const branchPosSelling =
          branch?.employee_info?.userBusinessGroup?.branchPosSelling[lastIndex];
        const response = await dispatch(
          posHandler.getHoldOrders(
            businessSlug,
            selectedDate,
            branchPosSelling.id
          )
        );
        const posTerminalResponse = dispatch(
          posHandler.getBranchPosById(businessSlug, currentBranchId)
        );
        setPointOfSaleInfo(posTerminalResponse);
        setHoldBill(response);
      }
    }, [
      dispatch,
      businessSlug,
      branchPOSSellingId,
      selectedDate,
      currentBranchId,
      branch,
    ]);

    useEffect(() => {
      if (modalOpenObj.modalOpen) {
        fetchBillItem();
      }
    }, [dispatch, fetchBillItem, modalOpenObj.modalOpen]);

    useEffect(() => {
      let fetchedBill = pendingBillConverter(recallBill);

      const formatHoldBill = convertOrdersToBillFormat(holdBill);
      const combindBill = [...fetchedBill, ...formatHoldBill];
      setBilldatalist(combindBill);
    }, [
      billItem,
      convertOrdersToBillFormat,
      holdBill,
      pendingBillConverter,
      pointOfSaleInfo,
      recallBill,
    ]);

    useImperativeHandle(ref, () => ({
      triggerRefresh: () => {
        fetchBillItem();
      },
    }));

    const handleRecallBill = async () => {
      if (!billdata) return;

      try {
        alertObj.setAlerttable(false);
        alertObj.setAlertproduct(false);

        if (billdata.billStatus === 1) {
          setOrders({
            ...billdata,
            __resetBeforeLoad: true,
          });
        } else {
          await dispatch(
            posHandler.updateHoldOrder(businessSlug, billdata.billID, {
              status: "ROLLBACK",
            })
          );
          setOrders(billdata);
        }
        setBilldata(false);
        modalOpenObj.setModalOpen(false);

        await fetchBillItem();
      } catch (error) {
        console.error("Error recalling bill:", error);
      }
    };

    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={modalOpenObj.modalOpen}
          onClose={() => modalOpenObj.setModalOpen(false)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={modalOpenObj.modalOpen && !loading}>
            <div
              className="bg-white focus-visible-none w-[min(64.11vw,662px)] p-[min(1.74vw,15px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)]"
              style={{ height: "calc(100vh - 100px)" }}
            >
              <div className=" mb-2 text-22 flex align-items-center font-[700] leading-[2.2]">
                <div className="me-auto text-18 font-[600] text-[#061126]">
                  เรียกบิล
                </div>
              </div>

              <div className="row gx-2">
                <div className="col-6 pe-1">
                  <div className="bg-[#F4F4F4]  p-[min(2.44vw,10px)] rounded-[min(0.78vw,8px)] ">
                    <div className=" mb-2">
                      <button
                        type="button"
                        className="btn btn-bill-status me-2"
                        style={
                          BillStatus === 2
                            ? {
                                background: "#2DC76D",
                                color: "#FFF",
                                border: "1px solid #2DC76D",
                              }
                            : {}
                        }
                        onClick={() => setBillStatus(2)}
                      >
                        บิลที่พัก
                      </button>
                      <button
                        type="button"
                        className="btn btn-bill-status"
                        style={
                          BillStatus === 1
                            ? {
                                background: "#2DC76D",
                                color: "#FFF",
                                border: "1px solid #2DC76D",
                              }
                            : {}
                        }
                        onClick={() => setBillStatus(1)}
                      >
                        บิลที่เปิดอยู่
                      </button>
                    </div>
                    <div className="mb-2">
                      <CustomInputSearch
                        inputprops={{
                          type: "text",
                          className: "search-input text-12 w-100 pt-2",
                          placeholder: "ค้นหา",
                          min: 0,
                          onChange: (e) => {},
                        }}
                        onKeyUp={(e) => setFilterText(e.target.value)}
                      />
                    </div>

                    <div className="bx-bill pe-2">
                      {billfilter &&
                        billfilter.map((item, index) => (
                          <div
                            className="card card-bill mb-2"
                            key={item.id}
                            onClick={() => {
                              setBilldata(item);
                            }}
                            style={{
                              border:
                                billdata &&
                                String(billdata.id) === String(item.id)
                                  ? "2px solid #2DC76D"
                                  : "",
                              boxShadow:
                                billdata &&
                                String(billdata.id) === String(item.id)
                                  ? "0 0 5px rgba(45, 199, 109, 0.5)"
                                  : "",
                              transition: "all 0.2s ease-in-out",
                            }}
                          >
                            <div className="d-flex align-items-center mb-1">
                              <div className="me-auto text-12 text-[#B6BBC6]">
                                {item.orderNo}
                              </div>
                              {item.billStatus === 1 ? (
                                <div className="bill-status-s2">
                                  เปิดบิลอยู่
                                </div>
                              ) : (
                                ""
                              )}
                              {item.billStatus === 2 ? (
                                <div className="bill-status-s1">พักบิล</div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="d-flex align-items-center text-16 text-[#061126] mb-1">
                              <div className="me-auto">
                                {item.customerName !== ""
                                  ? item.customerName
                                  : "-"}
                              </div>
                              <div>{item.orderPrice.sumprice}</div>
                            </div>
                            <div className="d-flex align-items-center">
                              <div className="me-2">
                                {item.delivery === 1 ? (
                                  <div className="dl1">ทานที่ร้าน</div>
                                ) : (
                                  ""
                                )}
                                {item.delivery === 2 ? (
                                  <div className="dl2">กลับบ้าน</div>
                                ) : (
                                  ""
                                )}
                                {item.delivery === 3 ? (
                                  <div className="dl3">เดลิเวอรี่</div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="text-[#B6BBC6] fs-10 me-1 pt-[1px]">
                                {item.tableName}
                              </div>
                              <div className="text-[#B6BBC6] fs-10 pt-[1px]">
                                {item.orderDate}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card card-body p-2">
                    <div className="d-flex align-items-center">
                      <div className="me-auto ">
                        <span className="text-14 text-[#2DC76D] me-2">
                          Order No.
                        </span>{" "}
                        <span className="text-14 text-[#2F4858]">
                          {billdata ? billdata.orderNo : "-"}
                        </span>
                      </div>
                      {billdata ? (
                        billdata.billStatus === 1 ? (
                          <div className="bill-status-s2">เปิดบิลอยู่</div>
                        ) : billdata.billStatus === 2 ? (
                          <div className="bill-status-s1">พักบิล</div>
                        ) : (
                          ""
                        )
                      ) : (
                        "-"
                      )}
                    </div>

                    <div>
                      <span className="text-14 text-[#2DC76D] me-2">
                        Receipt No.
                      </span>
                      <span className="text-[#2F4858] text-14">
                        {billdata ? billdata.receiptNo : "-"}{" "}
                      </span>
                    </div>
                    <div className="row g-0">
                      <div className="col">
                        <div>
                          <span className="text-12 text-[#2DC76D] me-2">
                            วันที่ :
                          </span>
                          <span className="text-12 text-[#2F4858] me-2">
                            {billdata ? billdata.orderDate : "-"}{" "}
                          </span>
                          <span className="text-12 text-[#2DC76D] me-2">
                            จุดขาย :
                          </span>
                          <span className="text-12 text-[#2F4858]">
                            {billdata ? billdata.pos : "-"}
                          </span>
                        </div>
                        <div>
                          <span className="text-12 text-[#2DC76D] me-2">
                            พนักงาน :
                          </span>
                          <span className="text-12 text-[#2F4858]">
                            {billdata ? billdata.staff : "-"}
                          </span>
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="text-14 text-[#2F4858] text-end mb-1">
                          Total
                        </div>
                        <div className="text-16 fw-500 text-[#2DC76D]">
                          {billdata ? billdata.orderPrice.sumprice : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="my-2">
                      {billdata && billdata.delivery === 1 ? (
                        <div className="dl1">ทานที่ร้าน</div>
                      ) : (
                        ""
                      )}
                      {billdata && billdata.delivery === 2 ? (
                        <div className="dl2">กลับบ้าน</div>
                      ) : (
                        ""
                      )}
                      {billdata && billdata.delivery === 3 ? (
                        <div className="dl3">เดลิเวอรี่</div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <div className="">
                        <div className="row gx-2 tc-17 fs-12">
                          <div className="col-7">รายการ</div>
                          <div className="col-2 text-center">จำนวน</div>
                          <div className="col-3 text-end">ราคา</div>
                        </div>
                      </div>
                      <hr className="mt-1 mb-0" />
                      <div
                        className="bx-main-order-list "
                        style={{ height: "calc(100vh - 440px)" }}
                      >
                        <ul className="p-0 m-0  w-100 ">
                          {billdata && billdata.product && (
                            <ProductOrderDetail
                              products={billdata.product}
                              handleClick={(id) => {
                                return false;
                              }}
                            />
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <CustomBtn
                      onClick={handleRecallBill}
                      disabled={billdata === false}
                      className={` leading-[0.8] w-fit min-w-[min(16.25vw,148px)] text-18 text-white font-[600] min-h-[min(5.51vw,57px)] rounded-[min(0.78vw,8px)] bg-[#FF731D] shadow-none`}
                      btntxt={"เรียกบิล"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
    );
  }
);

export default ModalCallBill;
